import { EntityAdapter, EntityState, createEntityAdapter } from "@ngrx/entity";
import { createActionGroup, createFeature, createReducer, createSelector, emptyProps, on, props } from "@ngrx/store";
import { CategoryPublic} from "./../../../globalTypes/category.types";
import { AuthUserActions } from "./authUser.store";

export interface CategoriesState extends EntityState<CategoryPublic> {
  category: CategoryPublic | null;
  categories: CategoryPublic[];
  isLoading: boolean;
}

const adapter: EntityAdapter<CategoryPublic> = createEntityAdapter<CategoryPublic>();

const getCategoriesState = (): CategoriesState => adapter.getInitialState({
  category: null,
  isLoading: true,
  categories: [],
})

export const CategoriesPageActions = createActionGroup({
  source: 'CATEGORIES',
  events: {
    'Categories Loading': (isLoading: boolean) => ({isLoading}),
    'Categories Loaded': props<{ categories: CategoryPublic[] }>(),
    'Category Updated': props<{ categoryId: number, category: Partial<CategoryPublic> }>(),
    'Categories Removed': props<{ categoryIds: number[] }>(),
    'Category Removed': props<{ categoryId: number }>(),
    'All Categories Removed': emptyProps(),
    'Set Stage View In Use Idx': (idx: number) => ({idx}),
    'Select Category': props<{ categoryId: number }>(),
  }
});

const reducer = createReducer(
  getCategoriesState(),
  on(CategoriesPageActions.categoriesLoading, (state, { isLoading }) => ({ ...state, isLoading })),
  on(CategoriesPageActions.categoriesLoaded, (state, action) => adapter.upsertMany(action.categories, { ...state, isLoading: false })),
  on(CategoriesPageActions.categoryUpdated, (state, action) => adapter.updateOne({id: action.categoryId, changes: action.category }, { ...state, isLoading: false })),
  on(CategoriesPageActions.categoriesRemoved, (state, action) => adapter.removeMany(action.categoryIds, { ...state, isLoading: false })),
  on(CategoriesPageActions.categoryRemoved, (state, action) => adapter.removeOne(action.categoryId, { ...state, isLoading: false })),
  on(CategoriesPageActions.allCategoriesRemoved, (state) => adapter.removeAll({ ...state, isLoading: false })),
  on(CategoriesPageActions.selectCategory, (state, action) => ({ ...state, category: state.categories.find(category=>category.id=== action.categoryId) || null })),
  on(AuthUserActions.logOut, (state) => (getCategoriesState())),
)
export const categoriesFeature = createFeature({
  name: 'categories',
  reducer,
  // extraSelectors: ({selectStageOptions, selectTagOptions, selectSelectedCategoryId, selectEntities, selectIds}) => ({
  //   selectCategories: createSelector(selectIds, selectEntities, (ids, entities) => ids ? ids.map((id) => entities[id]) : []),
  //   selectCategoriesByStageAndTag: createSelector(settingsFeature.selectCategoryViewType, selectStageOptions, selectTagOptions, selectIds, selectEntities, (categoryViewType, selectStages, selectTags, ids, entities) => {
  //     const stages: {[id:string]: Category[]} = selectStages.reduce((acc, opt)=>{acc[opt.id] = []; return acc},{});
  //     const tags: {[id:string]: Category[]} = selectTags.reduce((acc, opt)=>{acc[opt.id] = []; return acc},{});
  //     const categories: Category[] = ids
  //       .map(id=>entities[id] || {categoryNumber: 0, categoryType: "wardrobe"})
  //       .filter(category=>category && categoryViewType.includes(category.categoryType))
  //       .sort((a,b)=>a?.categoryNumber-b?.categoryNumber) as Category[];
  //     categories.forEach((category)=>{
  //       const stage = category.stage;
  //       if(!stages[stage]) return;
  //       stages[stage].push(category);
  //       category.tags.forEach(tag=>{if (tags[tag]) {tags[tag].push(category)}});
  //     })
  //     return {stages, tags};
  //   }),
  //   selectedCategory: createSelector(selectSelectedCategoryId, selectEntities, (id, entities) => id ? entities[id] : null),
  //   selectedCategoryDetails: createSelector(selectSelectedCategoryId, selectEntities, (id, entities) => id ? entities[id]?.details : null),
  // })
})
